import { useState } from 'react';
import { httpPost } from '../../../../../utils';

interface Props {
    onSuccessCallback: (fileName: string, data: string) => void;
    onErrorCallback: VoidFunction;
}

interface Response {
    data: {
        result: boolean;
        certificateData: string;
    } | null;
    status: number | null;
    error: unknown | null;
}

const uploadCertificate = async (formData: FormData) => {
    const reqUrl = `/Settings/UploadAzureEnterpriseAppCert`;
    const res: Response = await httpPost(reqUrl, formData);

    if (!res?.data?.result) {
        throw new Error('Failed to upload certificate');
    }

    return res.data.certificateData;
};
const useUploadAzureAppCert = ({ onSuccessCallback, onErrorCallback }: Props) => {
    const [isLoading, setIsLoading] = useState(false);

    const uploadCertificateMutation = async (file: File) => {
        setIsLoading(true);
        try {
            const formData = new FormData();
            formData.append('file', file);
            const certData = await uploadCertificate(formData);
            onSuccessCallback(file.name, certData);
        } catch (err) {
            onErrorCallback();
        } finally {
            setIsLoading(false);
        }
    };

    return { uploadCertificateMutation, isLoading };
};

export default useUploadAzureAppCert;
